// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// NGB bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { NgSelectModule } from '@ng-select/ng-select';

// Custom component
import { ReactiveFieldComponent } from './components/reactive-fields-component/reactive-field-component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { TextboxComponent } from './components/textbox/textbox.component';
import { ChipComponent } from './components/chip/chip.component';
import { SelectComponent } from './components/select/select.component';
import { RadioComponent } from './components/radio/radio.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { TimepickerComponent } from './components/timepicker/timepicker.component';
import { TextareaComponent } from './components/textarea/textarea.component';
import { SeparatorComponent } from './components/separator/separator.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
// import { AmazingTimePickerModule } from 'amazing-time-picker';

// Layout
import { ReactiveFormLayoutComponent } from './pages/reactive-form-layout/reactive-form-layout.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        // NgSelectModule,
        NgbModule,
        // TagInputModule,
        //  PartialsModule,
        // AmazingTimePickerModule
    ],
    declarations: [
        ReactiveFormLayoutComponent,
        CheckboxComponent,
        TextboxComponent,
        ChipComponent,
        SelectComponent,
        RadioComponent,
        DatepickerComponent,
        TimepickerComponent,
        TextareaComponent,
        SeparatorComponent,
        FileUploaderComponent,
        ReactiveFieldComponent
    ],
    exports: [
        ReactiveFormLayoutComponent,
        CheckboxComponent,
        TextboxComponent,
        ChipComponent,
        SelectComponent,
        RadioComponent,
        DatepickerComponent,
        ReactiveFieldComponent,
        TimepickerComponent,
        SeparatorComponent,
        FileUploaderComponent
    ]
})

export class CustomReactiveFormModule { }
